import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "text-r"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.attrIsShow,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    title: _ctx.attRow.attribute_id ? '编辑属性值' : '新增属性值',
    width: "440px"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.commonClick('cancel'))
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("取消")])),
      _: 1,
      __: [6]
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.commonClick('sure'))
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确认")])),
      _: 1,
      __: [7]
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-position": "right",
      "label-width": "150px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "所属属性",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.data.attrValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.attrValue = $event),
          placeholder: "",
          filterable: "",
          style: {
            "width": "80%"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.attrList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              label: item.name,
              value: item.attribute_id,
              key: index
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: '中文属性值名称',
        prop: "",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.data.attrName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.data.attrName = $event),
          placeholder: "请输入中文属性名称",
          style: {
            "width": "80%"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: '英文属性值名称',
        prop: "",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.data.attrNameEn,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.data.attrNameEn = $event),
          placeholder: "请输入英文属性名称",
          style: {
            "width": "80%"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "状态:",
        prop: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: _ctx.data.attrState,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.attrState = $event),
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["model-value", "title"]);
}